import { render, staticRenderFns } from "./addsourcemange.vue?vue&type=template&id=8075c7ae&scoped=true"
import script from "./addsourcemange.vue?vue&type=script&lang=js"
export * from "./addsourcemange.vue?vue&type=script&lang=js"
import style0 from "./addsourcemange.vue?vue&type=style&index=0&id=8075c7ae&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8075c7ae",
  null
  
)

export default component.exports